import apiClient from "./api/client";
import ENDPOINTS from "./api/endpoints";


const kitchenStationService = {
 
  getAll: async (params = {}) => {
    try {
      const response = await apiClient.get(ENDPOINTS.KITCHEN_STATIONS.BASE, { params });
      
      return response?.data || [];
    } catch (error) {
      console.error("Failed to fetch kitchen stations:", error);
      throw error;
    }
  },

 
  create: async (data) => {
    try {
      const response = await apiClient.post(ENDPOINTS.KITCHEN_STATIONS.CREATE, data);
      return response?.data || null;
    } catch (error) {
      console.error("Failed to create kitchen station:", error);
      throw error;
    }
  },


  update: async (id, data) => {
    try {
      const response = await apiClient.put(ENDPOINTS.KITCHEN_STATIONS.UPDATE(id), data);
      return response?.data || null;
    } catch (error) {
      console.error(`Failed to update kitchen station ${id}:`, error);
      throw error;
    }
  },

  
  delete: async (id) => {
    try {
      const response = await apiClient.delete(ENDPOINTS.KITCHEN_STATIONS.DELETE(id));
      return response?.data || null;
    } catch (error) {
      console.error(`Failed to delete kitchen station ${id}:`, error);
      throw error;
    }
  },

 
  activate: async (id) => {
    try {
      const response = await apiClient.put(ENDPOINTS.KITCHEN_STATIONS.ACTIVATE(id));
      return response?.data || null;
    } catch (error) {
      console.error(`Failed to activate kitchen station ${id}:`, error);
      throw error;
    }
  },

  
  deactivate: async (id) => {
    try {
      const response = await apiClient.put(ENDPOINTS.KITCHEN_STATIONS.DEACTIVATE(id));
      return response?.data || null;
    } catch (error) {
      console.error(`Failed to deactivate kitchen station ${id}:`, error);
      throw error;
    }
  },
};

export default kitchenStationService;
